export const SIZE_TYPES_SHOWING_IT_EQUIVALENCE = [
  "size_fr",
  "size_int",
  "size_double",
  "size_multiple",
];
